import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const EditZoneDefense = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  console.log(id);

  const [zonededefense, setZonededefense] = useState({
    name: '',
    libelle: '',
    observation: '',
  });
  const [file, setFile] = useState(null);

  // Récupérer les données de la zone de défense à éditer
  useEffect(() => {
    const fetchZoneDefense = async () => {
      try {
        const response = await axios.get(`zonededefenses/${id}`);
        setZonededefense(response.data);
      } catch (error) {
        toast.warn('Erreur lors de la récupération de la zone de défense');
      }
    };
    fetchZoneDefense();
  }, [id]);

  // Gestion du changement dans le formulaire
  const handleChange = (e) => {
    setZonededefense({
      ...zonededefense,
      [e.target.name]: e.target.value,
    });
  };

  // Gestion de l'upload d'image
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Envoi des données lors de la soumission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Créer un FormData pour envoyer le fichier et les données JSON
    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }

    formData.append('zonededefense', JSON.stringify(zonededefense)); // Envoyer les données JSON sous forme de chaîne de caractères

    try {
      const response = await axios.put(`zonededefenses/edit/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success(response.data.message);
      navigate('/zonededefenses');
    } catch (error) {
      toast.error(error.response.data.error);
    }
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col">
            <h1 className="alert alert-warning">Modification zone de defense</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <form onSubmit={handleSubmit} className="container mt-3 form-group">
              <div>
                <label>Nom</label>
                <input type="text" name="name" value={zonededefense.name} onChange={handleChange} className="form-control" />
              </div>
              <div>
                <label>Libellé</label>
                <input type="text" name="libelle" value={zonededefense.libelle} onChange={handleChange} className="form-control" />
              </div>
              <div>
                <label>Observation</label>
                <textarea name="observation" value={zonededefense.observation} onChange={handleChange} className="form-control" />
              </div>
              <div>
                <label>Image</label>
                <input className="mt-4" type="file" onChange={handleFileChange} />
              </div>
              <button type="submit" className="btn btn-primary btn-group-lg mt-4">
                Mettre à jour
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditZoneDefense;
